import React from 'react';
import styles from './ProfileRanks.module.css';
import cs2 from "../assets/cs2.png";
import dota2 from "../assets/dota2.jpeg";
import fortnite from "../assets/fortnite.png";
import valorant from "../assets/valorant.png"
import lol from "../assets/lol.jpeg"
import apexlegends from "../assets/apex.png"
import translations from './translation.js';

const gameLogos = {
  valorant: valorant,
  dota_2: dota2,
  league_of_legends: lol,
  fortnite: fortnite,
  cs2: cs2,
  apex_legends: apexlegends,
};

const ProfileRanks = ({ ranks, style }) => {
    const currentLanguage = localStorage.getItem('selectedLanguage') || "en";

    console.log(ranks);
    const allEmpty = ranks && Object.values(ranks).every(rank => rank === '');

    const filteredRanks = Object.fromEntries(
      Object.entries(ranks || {}).filter(([game, rank]) => rank !== translations[currentLanguage].unranked)
    );
    console.log(filteredRanks);
    return (
      <div className={`${styles.profileInfoContainer} ${styles[style]}`}>
        {Object.keys(filteredRanks).length > 0 ? (
          Object.entries(filteredRanks).map(([game, rank], index) => (
            <div key={index} className={styles.rankItem}>
              <img src={gameLogos[game]} alt={game} className={styles.gameLogo} />
              <p className={styles.rankText}>{translations[currentLanguage][rank]}</p>
            </div>
          ))
        ) : (
          <p className={styles.rankText}>{translations[currentLanguage].no_rank}</p>
        )}
      </div>
    );
  };
  
  export default ProfileRanks;
